export default {
  'common.select.placeholder': 'Please select',
  'common.enabled': 'Enabled',
  'common.disabled': 'Disabled',
  'common.select.actStatus.disabled': 'Disabled',
  'common.select.actStatus.enabled': 'Enabled',
  'common.select.actStatus.ended': 'Ended',
  'common.select.gameType.slot': 'Slot',
  'common.select.gameType.live': 'Live',
  'common.select.gameType.sport': 'Sport',
  'common.select.gameType.lottery': 'Lottery',
  'common.select.gameType.fish': 'Fish',
  'common.select.gameType.chess': 'Chess',
  'common.select.gameType.minigame': 'Minigame',
  'common.select.gameType.xlive': 'XLive',
  'common.select.gameType.esports': 'ESports',
  'common.select.gameType.arcade': 'Arcade',
  'common.select.gameType.bingo': 'Bingo',
  'common.select.gameType.unknown': 'Unknown',
  'common.select.pointAwardStatus.claimed': 'Claimed',
  'common.select.pointAwardStatus.expired': 'Expired',
  'common.select.actTemplateType.rebate': 'Bet Rebate',
  'common.select.actTemplateType.custom': 'Custom Promotion',
  'common.select.actTemplateType.realtimeRebate': 'VIP Game Rebate',
  'common.select.actTemplateType.register': 'Registration Bonus',
  'common.select.actTemplateType.dailyFirstRecharge': 'Daily First Recharge',
  'common.select.actTemplateType.recharge': 'Recharge Bonus',
  'common.select.actTemplateType.loginRecharge': 'Login Recharge Draw',
  'common.select.actTemplateType.luckySpin': 'Lucky Spin',
  'common.select.actTemplateType.everyRecharge': 'Every Recharge Bonus',
  'common.select.actTemplateType.invite': 'Invite Friends',
  'common.select.actTemplateType.infoBinding': 'Info Binding Bonus',
  'common.select.actTemplateType.redPacketRain': 'Red Packet Rain',
  'common.select.actTemplateType.firstDeposit': 'First Deposit Bonus',
  'common.select.actTemplateType.newRebate': 'New Betting Rebate',
  'common.select.manualSendUserStatus.notStarted': 'Not Started',
  'common.select.manualSendUserStatus.processing': 'Processing',
  'common.select.manualSendUserStatus.success': 'Success',
  'common.select.manualSendUserStatus.failed': 'Failed',
  'common.select.manualSendStatus.notStarted': 'Not Started',
  'common.select.manualSendStatus.processing': 'Processing',
  'common.select.manualSendStatus.completed': 'Completed',
  'common.select.awardType.cash': 'Cash',
  'common.select.awardType.points': 'Points',
  'common.select.awardType.fuel': 'Fuel',
  'common.select.actName.vipReward': 'VIP Reward',
  'common.select.actName.fissionActivity': 'Fission Activity',
  'common.select.balanceSubType.deposit': 'Deposit',
  'common.select.balanceSubType.withdraw': 'Withdraw',
  'common.select.balanceSubType.manualSend': 'Manual Send',
  'common.select.balanceSubType.upgradeReward': 'Upgrade Reward',
  'common.select.balanceSubType.retentionReward': 'Retention Reward',
  'common.select.balanceSubType.weeklySalary': 'Weekly Salary',
  'common.select.balanceSubType.monthlySalary': 'Monthly Salary',
  'common.select.balanceSubType.birthdayReward': 'Birthday Reward',
  'common.select.balanceSubType.upgradePoint': 'Upgrade Points',
  'common.select.balanceSubType.retentionPoint': 'Retention Points',
  'common.select.balanceSubType.appDayPoint': 'APP Daily Points',
  'common.select.balanceSubType.h5DayPoint': 'H5 Daily Points',
  'common.select.balanceSubType.realtimeRebate': 'VIP Game Rebate',
  'common.select.balanceSubType.rebate': 'Rebate',
  'common.select.balanceSubType.registerBonus': 'Registration Bonus',
  'common.select.balanceSubType.rechargeBonus': 'Deposit Bonus',
  'common.select.balanceSubType.dailyFirstRechargeBonus': 'Daily First Deposit Bonus',
  'common.select.balanceSubType.loginRechargeLoginBonus': 'Login',
  'common.select.balanceSubType.loginRechargeRechargeBonus': 'Recharge',
  'common.select.balanceSubType.redemptionCodeBonus': 'Redemption Code Bonus',
  'common.select.balanceSubType.luckySpinBonus': 'Lucky Spin Bonus',
  'common.select.balanceSubType.everyRechargeBonus': 'Every Recharge Bonus',
  'common.select.balanceSubType.inviteBonus': 'Invite Bonus',
  'common.select.balanceSubType.inviteAchievementBonus': 'Achievement Bonus',
  'common.select.balanceSubType.inviteeBonus': 'Invitee Bonus',
  'common.select.balanceSubType.infoBindingBonus': 'Info Binding Bonus',
  'common.select.balanceSubType.chickTreasureBoxBonus': 'Treasure Box Bonus',
  'common.select.balanceSubType.chickCheckinBonus': 'Check-in Bonus',
  'common.select.balanceSubType.redPacketRain': 'Red Packet Rain',
  'common.select.balanceSubType.treasureBoxDailyBonus': 'Treasure Box Daily Distribution',
  'common.select.balanceSubType.newRebateBonus': 'New Rebate Bonus',
  'common.select.balanceSubType.firstDepositBonus': 'First Deposit Bonus',
  'common.select.balanceSubType.vendorLeaderboardBonus': 'Leaderboard Activity Bonus',
  'common.select.balanceSubType.inviteDepositRebateBonus': 'Invite Deposit Rebate',
  'common.select.balanceSubType.inviteBetRebateBonus': 'Invite Bet Rebate',
  'common.select.balanceSubType.inviteWinLossRebateBonus': 'Invite Win/Loss Rebate',
  'common.select.balanceSubType.inviteNgrRebateBonus': 'Invite NGR Rebate',
  'common.select.balanceSubType.manualDeposit': 'Manual Deposit',
  'common.select.balanceSubType.gameTransferIn': 'Game Transfer In',
  'common.select.balanceSubType.gameTransferOut': 'Game Transfer Out',
  'common.select.balanceSubType.pointExchange': 'Point Exchange',
  'common.select.balanceSubType.actRechargeFuel': 'Recharge Fuel',
  'common.select.balanceSubType.actInviteFuel': 'Invite Fuel',
  'common.select.balanceSubType.actJeepneyEnterReward': 'Entry Reward',
  'common.select.balanceSubType.actJeepneyStageReward': 'Stage Reward',
  'common.select.balanceSubType.upgradeTicket': 'Upgrade Ticket',
  'common.select.balanceSubType.weeklyTicket': 'Weekly Ticket',
  'common.select.balanceSubType.monthlyTicket': 'Monthly Ticket',
  'common.select.balanceSubType.birthdayTicket': 'Birthday Ticket',
  'common.select.balanceSubType.appDailyTicket': 'APP Daily Ticket',
  'common.select.balanceSubType.h5DailyTicket': 'H5 Daily Ticket',
  'common.select.balanceSubType.weeklyPoint': 'Weekly Point',
  'common.select.balanceSubType.monthlyPoint': 'Monthly Point',
  'common.select.balanceSubType.birthdayPoint': 'Birthday Point',
  'common.select.balanceSubType.retentionTicket': 'Retention Ticket',
  'common.select.balanceSubType.appDailyPoint': 'APP Daily Point',
  'common.select.balanceSubType.h5DailyPoint': 'H5 Daily Point',
};
